if(!customElements.get('view-more')) {
  class ComponentViewMore extends HTMLElement {
    constructor() {
      super();
      this.viewMoreBtn = this.querySelector('.view-more-btn');
      this.viewLessBtn = this.querySelector('.view-less-btn');
      this.target = this.querySelector('.view-more-target');

      this.viewMoreBtn.addEventListener('click', ()=>{
        this.viewMoreBtn.classList.add('hide');
        this.viewLessBtn.classList.remove('hide');
        this.target.classList.remove('hide');
      });

      this.viewLessBtn.addEventListener('click', ()=>{
        this.viewMoreBtn.classList.remove('hide');
        this.viewLessBtn.classList.add('hide');
        this.target.classList.add('hide');
      });
    }


  }
  customElements.define('view-more', ComponentViewMore);
}